import axios from './index'
import qs from 'qs'
// 登出接口
export const loginOut = params => {
    return axios.post(`api/8210/user/loginOut`, qs.stringify(params))
}